<template>
  <div class="order-page">
    <div class="container">
      <div class="opera-btn-group">
        <el-form class="advanced-query-form">
          <el-row>
            <el-col :span="8">
              <oms-form-row :span="5" label="业务单据号">
                <oms-input placeholder="请输入业务单据号" type="text" v-model="searchCondition.objectNo"></oms-input>
              </oms-form-row>
            </el-col>
            <el-col :span="10">
              <oms-form-row :span="5" label="业务时间范围">
                <el-col :span="24">
                  <el-date-picker
                    v-model="bizDateAry"
                    format="yyyy-MM-dd"
                    placeholder="请选择" type="daterange">
                  </el-date-picker>
                </el-col>
              </oms-form-row>
            </el-col>
            <el-col :span="6">
              <oms-form-row :span="6" label="业务类型">
                <el-select filterable placeholder="请选择业务类型" v-model="searchCondition.bizType">
                  <el-option :key="item.key" :label="item.label" :value="item.value" v-for="item in bizTypes"/>
                </el-select>
              </oms-form-row>
            </el-col>
          </el-row>
          <el-row style="padding-top: 10px">
            <el-col :span="8">
              <oms-form-row :span="5" label="来源单位">
                <org-select :remote-method="queryDownList" placeholder="请输入名称/拼音首字母缩写/系统代码搜索来源单位"
                            v-model.trim="searchCondition.sourceOrgId" :list="downOrgList"/>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row :span="6" label="去向单位">
                <org-select :remote-method="queryDownList" placeholder="请输入名称/拼音首字母缩写/系统代码搜索去向单位"
                            v-model.trim="searchCondition.directionOrgId" :list="downOrgList"/>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row :span="6" label="">
                <el-button @click="searchInOrder" plain type="primary">查询</el-button>
                <el-button @click="resetSearchForm" native-type="reset">重置</el-button>
              </oms-form-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="order-list">
        <el-row class="order-list-header">
          <el-col :span="2">业务类型</el-col>
          <el-col :span="4">业务单据号</el-col>
          <el-col :span="6">来源单位</el-col>
          <el-col :span="6">去向单位</el-col>
          <el-col :span="3">业务时间</el-col>
          <el-col :span="3">创建时间</el-col>
        </el-row>
        <el-row v-if="loadingData">
          <el-col :span="24">
            <oms-loading :loading="loadingData"></oms-loading>
          </el-col>
        </el-row>
        <el-row v-else-if="!orderList.length">
          <el-col :span="24">
            <div class="empty-info">
              暂无信息
            </div>
          </el-col>
        </el-row>
        <div class="order-list-body flex-list-dom" v-else="">
          <div :class="[{'active':currentOrderId===item.id}]" @click.prevent="showItem(item)" class="order-list-item order-list-item-bg"
               v-for="item in orderList">
            <el-row type="flex">
              <el-col :span="2">{{filterBizType(item.bizType)}}</el-col>
              <el-col :span="4" class="R">{{item.objectNo}}</el-col>
              <el-col :span="6">{{item.sourceOrgName }}</el-col>
              <el-col :span="6">{{item.directionOrgName }}</el-col>
              <el-col :span="3">{{item.operateTime | minute }}</el-col>
              <el-col :span="3">{{item.createTime | minute }}</el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" v-show="(orderList.length) && !loadingData">
      <el-cu-pagination :current-page="pager.currentPage" :page-size="20"
                        :page-sizes="[20,50,100]"
                        :total="pager.count" @current-change="handleCurrentChange" @size-change="handleSizeChange"
                        layout="sizes, prev, pager, next, jumper">
      </el-cu-pagination>
    </div>
    <page-right :css="{'width':'1000px','padding':0}" :show="showDetail" @right-close="resetRightBox"
                class="order-detail-info" partClass="pr-no-animation">
      <show-form :filterBizType="filterBizType" :orderId="currentOrderId" @close="resetRightBox"></show-form>
    </page-right>
  </div>
</template>
<script>
  import showForm from './form/show.form.vue';
  import {bizTraces} from '@/resources';
  import DataMixin from '@/mixins/dataMixin';
  import MethodsMix from "@/mixins/methodsMinix";

  export default {
    components: {showForm},
    mixins: [DataMixin,MethodsMix],
    data: function () {
      return {
        loadingData: true,
        showDetail: false,
        showSearch: true,
        bizDateAry: '',
        orderList: [],
        filters: {
          orgId: '',
          objectNo: '',
          bizType: '',
          sourceOrgId: '',
          directionOrgId: '',
          operateStartTime: '',
          operateEndTime: ''
        },
        searchCondition: {
          orgId: '',
          objectNo: '',
          bizType: '',
          sourceOrgId: '',
          directionOrgId: '',
          operateStartTime: '',
          operateEndTime: ''
        },
        activeStatus: 0,
        currentOrderId: '',
        pager: {
          currentPage: 1,
          count: 0,
          pageSize: 20
        }
      };
    },
    mounted() {
      this.getOrderList(1);
    },
    watch: {
      filters: {
        handler: function () {
          // this.getOrderList(1);
        },
        deep: true
      }
    },
    methods: {
      searchInOrder: function () {// 搜索
        this.searchCondition.operateStartTime = this.$formatAryTime(this.bizDateAry, 0);
        this.searchCondition.operateEndTime = this.$formatAryTime(this.bizDateAry, 1);
        Object.assign(this.filters, this.searchCondition);
        this.getOrderList(1);
      },
      resetSearchForm: function () {// 重置表单
        let temp = {
          orgId: '',
          objectNo: '',
          bizType: '',
          sourceOrgId: '',
          directionOrgId: '',
          operateStartTime: '',
          operateEndTime: ''
        };
        Object.assign(this.searchCondition, temp);
        Object.assign(this.filters, temp);
        this.getOrderList(1);
      },
      resetRightBox: function () {
        this.showDetail = false;
        // this.$router.push('/search/business');
      },
      handleSizeChange(val) {
        this.pager.pageSize = val;
        this.getOrderList(1);
      },
      handleCurrentChange(val) {
        this.getOrderList(val);
      },
      getOrderList: function (pageNo) {
        if (pageNo === 1) {
          this.pager.count = 0;
        }
        this.pager.currentPage = pageNo;
        let param = {};
        this.loadingData = true;
        param = Object.assign({}, this.filters, {
          pageNo: pageNo,
          pageSize: this.pager.pageSize
        });
        bizTraces.query(param).then(res => {
          this.orderList = res.data.list;
          this.pager.count = this.pager.currentPage * this.pager.pageSize + (this.orderList.length === this.pager.pageSize ? 1 : 0);
          this.loadingData = false;
        });
      },
      showItem: function (order) {
        this.currentOrderId = order.id;
        this.showDetail = true;
        // this.$router.push(`/search/business/${order.id}`);
      },
      formatTimeAry(times, index, str) {
        if (!times) return;
        return this.formatTime(times[index], str);
      },
      formatTime(time, str = 'YYYY-MM-DD HH:mm:ss') {
        return time ? this.$moment(time).format(str) : '';
      }
    }
  };
</script>
